import { render, staticRenderFns } from "./LoansScheduleDetails.vue?vue&type=template&id=dcf5b0fc"
import script from "./LoansScheduleDetails.vue?vue&type=script&lang=js"
export * from "./LoansScheduleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports